import React from "react";

const BillingHeader = ({ headerData }: { headerData: any }) => {
  const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "6px",
    marginBottom: "4px",
    width: "100%",
  };
  const logoContainerStyle = {
    width: "20%",
    display: "flex",
    alignItems: "center",
  };
  const logoStyle = {
    maxHeight: "40px",
    width: "auto",
    objectFit: "contain",
  };
  const rightContainerStyle = {
    width: "80%",
    textAlign: "right",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  };
  const nameStyle = {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "2px",
  };
  const textStyle = {
    fontSize: "12px",
    lineHeight: "16px",
  };

  return (
    <>
      <div style={containerStyle}>
        <div style={logoContainerStyle}>
          {headerData?.logoServerImage && (
            <img
              src={`data:image/png;base64,${headerData?.logoServerImage}`}
              alt="Logo"
              style={logoStyle}
            />
          )}
        </div>
        <div style={rightContainerStyle}>
          <div style={nameStyle}>
            {headerData?.consumerName}
            {headerData?.branchName && ` (${headerData.branchName})`}
          </div>
          <div style={textStyle}>
            {headerData?.address1} {headerData?.address2}
          </div>
          <div style={textStyle}>
            {headerData?.email && `Email: ${headerData.email}`}
            {headerData?.mobileNumber &&
              `, Mobile No.: ${headerData.mobileNumber}`}
          </div>
          <div style={textStyle}>
            {headerData?.landLineNumber &&
              `LandLine No.: ${headerData.landLineNumber}`}
          </div>
        </div>
      </div>
    </>
  );
};

export default BillingHeader;
